module.exports = __webpack_public_path__ + "static/media/close.6a39495f.svg";